// import { createStore } from "redux";
// import rootred from "../reducers/main";
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import RootReducers from '../RootReducers';

const storageConfig = {
  key: 'root',
  storage
}

const persistedReducer = persistReducer(storageConfig, RootReducers);

const Store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);

export default Store;
